module.exports = __webpack_public_path__ + "static/media/ne.e48580ce.png";